import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Colors } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { AssetRoutinesForm } from './assetRoutinesForm';

type RoutinesButtonProps = {
  routinesCount: number;
  assetId: string;
  name: string;
};

export const RoutinesButton = ({ routinesCount, assetId, name }: RoutinesButtonProps) => {
  const { t } = useTranslation();

  const getLabel = (labelStyle: any, label: string) => {
    return <Text style={[labelStyle, styles.cellText]}>{label}</Text>;
  };

  return (
    <ModalButton
      label=""
      customButton={
        <View style={[styles.iconContainer]}>
          <MaterialCommunityIcons
            name="format-list-checks"
            color={Colors.blue}
            size={16}
            style={styles.icon}
          />
          {getLabel(styles.countText, (routinesCount ?? 0).toString())}
        </View>
      }
      modalComponent={({ onComplete }: { onComplete: () => void }) => {
        return (
          <AssetRoutinesForm
            assetId={assetId}
            title={name}
            onComplete={onComplete}
          />
        );
      }}
      containerStyle={styles.modalContainer}
    />
  );
};

const styles = StyleSheet.create({
  iconContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  icon: {
    marginRight: 2,
  },
  countText: {
    fontSize: 16,
  },
  cellText: {
    fontSize: 16,
    fontWeight: '500',
    flexWrap: 'nowrap',
  },
  modalContainer: {
    width: 640,
    height: '80%',
    minHeight: 450,
    alignSelf: 'center',
    backgroundColor: '#F5F5F5',
    borderRadius: 10,
  },
}); 